import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import submit from "submit-form";
import Modal from "../../../../../parts/modal-new";
import SvgIcon from "../../../../../parts/SvgIcon";
import { buildCreateMealPlanBody } from "../../../../../utils/meal-planner-helper";

export const CreateMealPlanModal = ({ locals }) => {
  const { t } = useTranslation("athlete-portal");
  const { activeUserToRequest, query, nutritionPlans = [] } = locals;
  const { athlete, plan } = query;
  const coachId = activeUserToRequest._id;
  const currentPlan = nutritionPlans.find(({ _id }) => _id === plan);
  const {
    utcStartDate,
    utcEndDate,
    userId,
    _id: nutritionPlanId,
  } = currentPlan;

  /**
   * Function to create a meal plan
   * @param {*} e
   */
  const handleCreateMealPlan = (e, planMode) => {
    e.preventDefault();

    const body = buildCreateMealPlanBody({
      planMode,
      utcStartDate,
      utcEndDate,
      athleteId: userId,
      coachId,
      nutritionPlanId,
    });
    submit(`/actions/meal-planner/create-meal-plan?proxyAthlete=${athlete}`, {
      method: "POST",
      body,
    });
  };

  return (
    <Modal
      className="create-meal-plan-modal"
      title={t("createMealPlanModal.title")}
    >
      <div className="body">
        <CreateMealPlanModalOption
          title={t("createMealPlanModal.simplifiedTitle")}
          description={t("createMealPlanModal.simplifiedDescription")}
          image="file-lines-regular-full"
          planMode="simplified"
          onCreate={handleCreateMealPlan}
        />
        <CreateMealPlanModalOption
          title={t("createMealPlanModal.detailedTitle")}
          description={t("createMealPlanModal.detailedDescription")}
          image="file-regular-full"
          planMode="detailed"
          onCreate={handleCreateMealPlan}
        />
      </div>
    </Modal>
  );
};

const CreateMealPlanModalOption = ({
  title,
  description,
  image,
  planMode,
  onCreate,
}) => {
  return (
    <button className="card" onClick={(e) => onCreate(e, planMode)}>
      <div className="card-information">
        <div className="card-icon">
          <SvgIcon src={`/img/new-icons/${image}.svg`} alt="icon" />
        </div>
        <div className="text">
          <p className="p1 mb-0.5">{title}</p>
          <p className="s3">{description}</p>
        </div>
      </div>
      <SvgIcon src="/img/new-icons/arrow-right.svg" alt="icon" />
    </button>
  );
};

CreateMealPlanModal.propTypes = {
  locals: PropTypes.object,
};
